import React, { useEffect, useState } from "react";
import { Box } from "../../../../components/styled/Elements";
import PhoneSignin1 from "./PhoneSignin1";
import PhoneSignin2 from "./PhoneSignin2";
import { useNavigate } from "react-router-dom";
import {
  auth
} from "../../../../firebaseService/firebase";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const phoneSigninSteps = [
  {
    label: "wellcome_back",
    component: PhoneSignin1,
  },
  {
    label: "we_just_texted_you",
    component: PhoneSignin2,
  },
];

const PhoneSigninForm = () => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(phoneSigninSteps[0]);
  const [phone, setPhone] = useState("");

  const currentStepIndex = phoneSigninSteps.indexOf(currentStep);

  const handleSteps = () => {
    if (currentStepIndex < 1)
      setCurrentStep(phoneSigninSteps[currentStepIndex + 1]);
    else return;
  };

  const setupRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: () => {
            console.log("ReCAPTCHA verified!");
          },
        },
      );
    }
  };

  const handleSendOtp = async (otpFieldRef = null) => {
    const appVerifier = window.recaptchaVerifier;

    try {
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        phone,
        appVerifier
      );

      if (confirmationResult.verificationId) {
        window.confirmationResult = confirmationResult;
        toast.success(t("otp_sent"));
        otpFieldRef?.current?.resetTimer();
        handleSteps();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    setupRecaptcha();
    return () => {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
      }
    };
  }, []);

  return (
    <Box>
      <Box id="recaptcha-container"></Box>
      <currentStep.component
        handleSteps={handleSteps}
        handleSendOtp={handleSendOtp}
        setPhone={setPhone}
      />
    </Box>
  );
};

export default PhoneSigninForm;
